<template>
  <v-container id="final-lineup" pt-0 pb-3 px-3>
    <div id="suspect-lineup-container">
      <img
        class="suspect-image"
        v-for="(suspect,i) in suspects"
        :key="`suspect-${i+1}`"
        :src="suspect.enlargedMugshot.url"
      >
    </div>
    <v-dialog
      content-class="fdi-final-lineup-modal"
      class="border-radius-15"
      persistent
      max-width="280"
      :value="true"
    >
      <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
        <v-container pa-0>
          <v-card-text>
            <p class="fs-36 text-xs-center white--text mt-3">Final Lineup</p>
            <p class="fs-24 text-xs-center white--text">View your Suspect lineup to look for clues</p>
            <v-btn
              class="button-border-beige"
              flat
              block
              color="#D6B682"
              @click="viewLineup"
            >View Suspect Lineup</v-btn>
          </v-card-text>
        </v-container>
        <v-card-actions class="mt-3">
          <v-btn flat>
            <v-img :src="backButton" @click="goBack"/>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="view-suspect-button" color="white" flat @click="goForward">Guess Who Did It</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Viewer from "viewerjs";
import backButton from "../../assets/directions/back_button.png";
export default {
  name: "final-lineup",
  props: {
    step: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      backButton,
      showSnackbar: false
    };
  },
  computed: {
    suspects() {
      return this.$store.getters.suspects;
    }
  },
  methods: {
    goBack() {
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.$store.dispatch("incrementStep");
    },
    viewLineup() {
      const gallery = document.getElementById("suspect-lineup-container");
      var that = this;
      gallery.addEventListener("hidden", function() {
        viewer.destroy();
        that.showSnackbar = false;
      });
      const viewer = new Viewer(gallery, {
        navbar: true,
        title: false,
        toolbar: {
          prev: true,
          play: true,
          next: true,
          reset: true
        },
        rotatable: false,
        scalable: false,
        show: i => {
          console.log(i);
        }
      });
      viewer.show();
      this.showSnackbar = true;
    }
  }
};
</script>

<style scoped>
#final-lineup {
  position: absolute;
  top: 110px;
  bottom: 0px;
}

#bulletin-container {
  height: 90%;
}

.view-suspect-button {
  border: 3px solid white;
}

#suspect-lineup-container {
  position: absolute;
}

.suspect-image {
  position: absolute;
  height: 0;
  width: 0;
}

#snackbar {
  z-index: 15000;
}
</style>
